import _ from 'lodash';
import { Order, Data } from './model';
import * as Devices from '../devices';
import * as DTHelper from '../datatable/utils';
import { AppKeys, newMsg } from '../../core/localization';
import { GroupNames, Groups } from '../../models';

export const msgTitle = newMsg(GroupNames[Groups.ORDERS]);

export const msgOrder = newMsg(AppKeys.Groups_Col_OrderId);
export const msgNumDevices = newMsg(AppKeys.Groups_Col_NumDevices);
export const msgInvoiceDate = newMsg(AppKeys.Groups_Col_Date);
export const keyTotalOrders = AppKeys.Num_Order;

export const msgSearchError = newMsg(AppKeys.Orders_Search_Error);

export const getPK = (order: Order): string => order.orderNumber;

export const getLoadedOrders = DTHelper.concatPageItems;

export const getSelectedOrders = (
  loadedorders: Order[],
  selectedKeys: string[]
) => loadedorders.filter((d) => selectedKeys.includes(getPK(d)));

export const getNumDevicesFromOrders = (selectedKeys: string[], data: Data) => {
  const orders = getSelectedOrders(getLoadedOrders(data.pages), selectedKeys);
  return _.sum(orders.map((o) => o.numDevices));
};

export const getTotalsFromSelectedKeys = (
  selectedKeys: string[],
  data: Data
) => {
  const orders = getSelectedOrders(getLoadedOrders(data.pages), selectedKeys);
  return orders
    .map((o) => o.totalsByType)
    .reduce(
      (prev, t) => {
        prev.totalConcentrators += t.totalConcentrators;
        prev.totalGateways += t.totalGateways;
        prev.totalMeters += t.totalMeters;
        prev.totalRepeaters += t.totalRepeaters;
        prev.totalValves += t.totalValves;
        return prev;
      },
      { ...Devices.TotalsByTypeDefault }
    );
};
